<!-- =========================================================================================
  File Name: List.vue
  Description: Device List page
========================================================================================== -->

<template>

  <div id="page-devices-list">

    <vs-prompt
        title="Новое уведомление"
        cancel-text= "Отменить"
        accept-text= "Создать"
        button-cancel = "border"
        @cancel="clearFields"
        @accept="createNotify"
        @close="clearFields"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-2" placeholder="Заголовок" v-model="notifyLocal.header" :color="validateForm ? 'success' : 'danger'" />
                        <vs-textarea rows="5" label="Содержание" v-model="notifyLocal.text" />
                        <vs-select v-model="notifyLocal.type" label="Тип уведомления" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in notifyTypeList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>

    <vx-card ref="filterCard" title="Фильтры" class="devices-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Программа</label>
          <v-select :options="programsOptions()" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="programsFilter" class="mb-4 md:mb-0" />
        </div> -->
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Разрешение</label>
          <v-select :options="enableOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="enableFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Активация</label>
          <v-select :options="activateOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="activateFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Подключение</label>
          <v-select :options="connectOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="connectFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Тип устройства</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">



        <!-- ITEMS PER PAGE -->
        <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ devicesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : devicesData.length }} of {{ devicesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="pl-4 pr-4 cursor-pointer flex-shrink">

          <div class="sm:mr-4 p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Действия</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="showPromptJoin">
                <feather-icon icon="DownloadIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Связать с партнером</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-success" @click="confirmCreateNotify">
                <feather-icon icon="PlusIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Создать уведомление</span>
              </span>
            </vs-dropdown-item>


            <!-- <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="showPromptUnjoin()">
                <feather-icon icon="UploadIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Отвязать от партнера</span>
              </span>
            </vs-dropdown-item> -->

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="gridApi.exportDataAsCsv()">
                <feather-icon icon="SaveIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Экспорт CSV</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-success" @click="confirmEnableDevices">
                <feather-icon icon="CheckIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Разрешить</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-warning" @click="confirmDisableDevices">
                <feather-icon icon="XIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Запретить</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="showPromptIdent">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Изменить сер.номер</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="confirmDisconnectDevices">
                <feather-icon icon="PowerIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Отключить</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="confirmDeleteDevices">
                <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Удалить</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown>


        <div class="flex-shrink">

          <vs-button color="success" icon-pack="feather" icon="icon-plus" class="mr-4" :to="{name: 'apps-devices-create'}">Создать</vs-button>

        </div>

        <div class="flex-grow">

          <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="updateDevices">Обновить</vs-button>
        
        </div>


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->


      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="devicesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>

    <!-- DEVICE CHANGE IDENT DIALOG -->
    <device-ident :displayPrompt="displayPromptIdent" :device="gridApi.getSelectedRows()[0]" @hidePromptIdent="hidePromptIdent" v-if="displayPromptIdent"></device-ident>

    <!-- PARTNER JOIN DIALOG -->
    <partner-join :displayPrompt="displayPromptJoin" :devices="gridApi.getSelectedRows()" @hidePromptJoin="hidePromptJoin" v-if="displayPromptJoin"></partner-join>
    
    <!-- PARTNER UNJOIN DIALOG -->
    <!-- <partner-unjoin :displayPrompt="displayPromptUnjoin" :devices="gridApi.getSelectedRows()" @hidePromptUnjoin="hidePromptUnjoin" v-if="displayPromptUnjoin"></partner-unjoin> -->

  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleDevice from '@/store/device/moduleDevice.js'
import moduleNotify from '@/store/notify/moduleNotify.js'

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue"
import CellRendererEnable from "./cell-renderer/CellRendererEnable.vue"
import CellRendererActivate from "./cell-renderer/CellRendererActivate.vue"
import CellRendererConnect from "./cell-renderer/CellRendererConnect.vue"
import CellRendererType from "./cell-renderer/CellRendererType.vue"

import DeviceIdent            from "./DeviceIdent.vue"
import PartnerJoin            from "./PartnerJoin.vue"
import PartnerUnjoin            from "./PartnerUnjoin.vue"


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererEnable,
    CellRendererActivate,
    CellRendererConnect,
    CellRendererType,
    
    DeviceIdent,
    PartnerJoin,
    PartnerUnjoin,
  },
  data() {
    return {
      displayPromptIdent        : false,
      displayPromptJoin        : false,
      displayPromptUnjoin        : false,


      enableFilter: { label: 'Все', value: 'all' },
      enableOptions: [],

      activateFilter: { label: 'Все', value: 'all' },
      activateOptions: [],

      connectFilter: { label: 'Все', value: 'all' },
      connectOptions: [],

      typeFilter: { label: 'Все', value: 'all' },
      typeOptions: [],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'did',
          width: 110,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Серийный номер',
          field: 'ident',
          filter: true,
          width: 200,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'SIM-карта',
          field: 'number',
          filter: true,
          width: 150,
        },
        {
          headerName: 'Разрешение',
          field: 'enable',
          // filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererEnable'
        },
        {
          headerName: 'Активация',
          field: 'activate',
          filter: false,
          width: 150,
          cellRendererFramework: 'CellRendererActivate'
        },
        {
          headerName: 'Подключение',
          field: 'online',
          filter: false,
          width: 160,
          cellRendererFramework: 'CellRendererConnect'
        },
        {
          headerName: 'Тип устройства',
          field: 'type',
          filter: false,
          width: 200,
          cellRendererFramework: 'CellRendererType'
        },
        {
          headerName: 'Пинг',
          field: 'ping',
          filter: false,
          width: 100,
        },
        {
          headerName: 'Версия',
          field: 'version',
          filter: true,
          width: 200,
        },
      ],

      activePrompt: false,

      notifyLocal: {
        header: "",
        text: "",
        type: 0,
      },
      notifyTypeList: moduleNotify.notifyTypeList,

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererEnable,
        CellRendererActivate,
        CellRendererConnect,
        CellRendererType,
      }
    }
  },
  watch: {
    enableFilter(obj) {
      this.setColumnFilter("enable", obj.value)
    },
    activateFilter(obj) {
      this.setColumnFilter("activate", obj.value)
    },
    connectFilter(obj) {
      this.setColumnFilter("online", obj.value)
    },
    typeFilter(obj) {
      this.setColumnFilter("type", obj.value)
    },
  },
  computed: {
    devicesData() {
      return this.$store.state.device.devices
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    validateForm() {
        return !this.errors.any() && this.notifyLocal.header != '' && this.notifyLocal.text != ''
    }
  },
  methods: {
    showPromptIdent() {
      if (this.gridApi.getSelectedRows().length == 1) {
        this.displayPromptIdent = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Изменение серийного номера`,
          text: `Необходимо выбрать из списка одно устройство, которое хотите изменить.`,
          acceptText: "Ок",
        })
      }
      
    },
    hidePromptIdent() {
      this.displayPromptIdent = false
      setTimeout(() => {
        // это место в реальной ситуации может некорректно работать
        this.updateDevices()
      }, 200)
      
    },
    showPromptJoin() {
      if (this.gridApi.getSelectedRows().length) {
        this.displayPromptJoin = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Связывание устройств`,
          text: `Необходимо выбрать из списка хотя бы одно устройство, которое хотите связать с партнером.`,
          acceptText: "Ок",
        })
      }
      
    },
    hidePromptJoin() {
      this.displayPromptJoin = false
    },
    showPromptUnjoin() {
      if (this.gridApi.getSelectedRows().length) {
        this.displayPromptUnjoin = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Отвязывание устройств`,
          text: `Необходимо выбрать из списка хотя бы одно устройство, которое хотите отвязать от партнера.`,
          acceptText: "Ок",
        })
      }
      
    },
    hidePromptUnjoin() {
      this.displayPromptUnjoin = false
    },

    confirmDisconnectDevices() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Отключение устройств`,
          text: `Вы действительно хотите отключить от сети все выделенные устройства?`,
          accept: this.disconnectDevices,
          acceptText: "Отключить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Отключение устройств`,
          text: `Выберите из списка устройства, которые хотите отключить от сети.`,
          acceptText: "Ок",
        })
      }
    },
    disconnectDevices() {
      this.$store.dispatch("device/disconnectDevices", this.gridApi.getSelectedRows())
      .then(() => {
        this.updateDevices()
      })
    },
    confirmEnableDevices() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: `Разрешение для устройств`,
          text: `Вы действительно хотите установить разрешение для всех выделенных устройств?`,
          accept: this.enableDevices,
          acceptText: "Разрешить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Разрешение для устройств`,
          text: `Выберите из списка устройства, для которых хотите установить разрешение.`,
          acceptText: "Ок",
        })
      }
    },
    enableDevices() {
      this.$store.dispatch("device/enableDevices", this.gridApi.getSelectedRows())
      .then(() => {
        this.updateDevices()
      })
    },
    confirmDisableDevices() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Запрет для устройств`,
          text: `Вы действительно хотите установить запрет для всех выделенных устройств?`,
          accept: this.disableDevices,
          acceptText: "Запретить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Запрет для устройств`,
          text: `Выберите из списка устройства, для которых хотите установить запрет.`,
          acceptText: "Ок",
        })
      }
    },
    disableDevices() {
      this.$store.dispatch("device/disableDevices", this.gridApi.getSelectedRows())
      .then(() => {
        this.updateDevices()
      })
    },

    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.enableFilter = this.activateFilter = this.connectFilter = this.typeFilter = { label: 'Все', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    updateDevices() {
      this.$store.dispatch("device/fetchDevices")
      .then(() => {
        this.updateSearchQuery(this.searchQuery)
        // сбрасываем фильтры, иначе нужно найти способ обновить таблицу согласно выбранным фильтрам
        this.enableFilter = this.activateFilter = this.connectFilter = this.typeFilter = { label: 'Все', value: 'all' }
      })
    },
    confirmDeleteDevices() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Удаление устройств`,
          text: `Вы действительно хотите удалить все выделенные устройства?`,
          accept: this.deleteDevices,
          acceptText: "Удалить",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Удаление устройств`,
          text: `Выберите из списка устройства, которые хотите удалить.`,
          acceptText: "Ок",
        })
      }
    },
    deleteDevices() {
      this.$store.dispatch("device/deleteDevices", this.gridApi.getSelectedRows())
    },

    confirmCreateNotify() {
      if (this.gridApi.getSelectedRows().length) {
        this.activePrompt = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Создание уведомления`,
          text: `Выберите из списка устройства, для которых хотите создать уведомление.`,
          acceptText: "Ок",
        })
      }
    },
    createNotify() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('notify/createNotifyDev', Object.assign({devices: this.gridApi.getSelectedRows()}, this.notifyLocal))
          this.clearFields()
        }
      })
    },

    clearFields() {
      Object.assign(this.notifyLocal, {
        header: "",
        text: "",
        type: 0,
      })
    },

  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {


    if (!moduleNotify.isRegistered) {
      this.$store.registerModule('notify', moduleNotify)
      moduleNotify.isRegistered = true
    }
    // this.$store.dispatch("notify/fetchNotify")

    if (!moduleDevice.isRegistered) {
      this.$store.registerModule('device', moduleDevice)
      moduleDevice.isRegistered = true
    }


    this.$store.dispatch("device/fetchDevices")
    .then(() => {
      let did = this.$route.params.deviceId
      if (did) {
        this.searchQuery = did
        this.updateSearchQuery(did)
      }
    })

    this.enableOptions = Object.assign([], moduleDevice.deviceEnableList)
    this.enableOptions.unshift({ label: 'Все', value: 'all' })

    this.activateOptions = Object.assign([], moduleDevice.deviceActivateList)
    this.activateOptions.unshift({ label: 'Все', value: 'all' })

    this.connectOptions = Object.assign([], moduleDevice.deviceConnectList)
    this.connectOptions.unshift({ label: 'Все', value: 'all' })

    this.typeOptions = Object.assign([], moduleDevice.deviceTypeList)
    this.typeOptions.unshift({ label: 'Все', value: 'all' })
  },
}

</script>

<style lang="scss">
#page-devices-list {
  .ag-theme-material .ag-cell {
    padding-right: 10px;
  }
  .vs__selected-options {
    max-width: 100%;
  }
  .vs__selected {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 85%;
  }
  .devices-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
